import { motion } from "framer-motion";
import { FUNDS } from "./data";
import { Reveal, SectionHead, EASE } from "./shared";

const TOTAL = FUNDS.reduce((s, f) => s + f.amount, 0);
const fmt = (n) => `$${Math.round(n / 1000)}K`;

export default function Funds() {
  return (
    <section id="funds" data-testid="funds-section" className="mx-auto max-w-7xl px-5 py-24 lg:px-8 lg:py-32">
      <SectionHead
        index="03"
        overline="Use of Funds"
        title="Where the $250K goes"
        note="Five lines, no mystery. Founder ops is stated openly — runway is the point of a bridge."
      />

      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
        <div className="lg:col-span-8">
          {FUNDS.map((f, i) => {
            const pct = Math.round((f.amount / TOTAL) * 100);
            return (
              <Reveal key={f.label} delay={i * 0.07}>
                <div data-testid={`funds-row-${i}`} className="border-t border-slate-800 py-6 last:border-b">
                  <div className="flex flex-wrap items-baseline justify-between gap-2">
                    <p className="font-display text-xl font-semibold uppercase tracking-wide text-slate-100">
                      {f.label}
                    </p>
                    <p className="font-mono text-sm text-slate-300">
                      <span className="text-[#FF5500]">{fmt(f.amount)}</span>
                      <span className="text-slate-500"> · {pct}%</span>
                    </p>
                  </div>
                  <div className="mt-3 h-1.5 w-full overflow-hidden rounded-full bg-slate-800">
                    <motion.div
                      initial={{ width: 0 }}
                      whileInView={{ width: `${pct}%` }}
                      viewport={{ once: true }}
                      transition={{ duration: 1, delay: 0.2 + i * 0.08, ease: EASE }}
                      className="h-full rounded-full bg-[#FF5500]"
                    />
                  </div>
                  <p className="mt-2 text-sm text-slate-500">{f.note}</p>
                </div>
              </Reveal>
            );
          })}
          <Reveal delay={0.35}>
            <div data-testid="funds-total" className="flex items-baseline justify-between pt-6">
              <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-400">Total bridge</p>
              <p className="font-display text-3xl font-semibold text-[#FF5500]">$250K</p>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.15} className="lg:col-span-4">
          <div className="clip-frame border border-slate-800 bg-[#0D1320] p-7 lg:sticky lg:top-24">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#FF5500]">What it buys</p>
            <ul className="mt-5 space-y-4">
              {[
                "Full-time runway to run founding pilots",
                "Founding pilots on active jobsites at the $1,000 offer",
                "Additional provisional patent filings (CCTV and robotics)",
                "Evidence for the $4.5M round that follows",
              ].map((item, i) => (
                <li key={i} className="flex gap-3 text-sm leading-relaxed text-slate-300">
                  <span className="font-mono text-xs text-[#FF5500]">0{i + 1}</span>
                  {item}
                </li>
              ))}
            </ul>
            <p className="mt-6 border-t border-slate-800 pt-5 text-sm leading-relaxed text-slate-500">
              What it does not buy: a seed-round story. That raise comes later, priced on evidence
              from these pilots.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
